import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/consulting.css';
import Bg from '../images/Event/consulting/bg.png';

class EventConsulting extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    window.pageVisit('consulting');
    window.addEventListener("scroll", this.onScroll);
  }

  onScroll = (e) => {
    const scrollTop = ("scroll", e.srcElement.scrollingElement.scrollTop);
    this.setState({scrollTop: scrollTop});
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont consulting" style={{background: '#fff'}}>
              <div id="contents" style={{background: '#fff'}}>
                <img src={Bg} style={{width: '100%'}} />
                <a href="http://www.kcoach.education/" target="_blank" className="Btn" onClick={() => window.pageComplete('consulting')}></a>
                <Link to="/event/branch/101" className={`banner ${this.state.scrollTop > 500 ? "show" : ""}`}></Link>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default EventConsulting;
